import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import MobileBenefitsModal from './MobileBenefitsModal';
import './Auth.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <MobileBenefitsModal />
      <div className="auth-content-wrapper">
        <div className="auth-benefits">
          <h2 className="auth-benefits-title">Your Literary Companion</h2>
          <p className="auth-benefits-subtitle">Start for free and unlock powerful reading resources</p>
          <ul className="auth-benefits-list">
            <li>
              <span className="benefit-icon">📚</span>
              <div>
                <h3>AI-Powered Summaries</h3>
                <p>Get comprehensive, detailed summaries of any book to enhance your understanding</p>
              </div>
            </li>
            <li>
              <span className="benefit-icon">💬</span>
              <div>
                <h3>Interactive Q&A</h3>
                <p>Ask questions about any book and receive intelligent, contextual answers</p>
              </div>
            </li>
            <li>
              <span className="benefit-icon">📖</span>
              <div>
                <h3>Study Guides & Discussion Outlines</h3>
                <p>Generate chapter-by-chapter study guides perfect for book clubs and academic study</p>
              </div>
            </li>
            <li>
              <span className="benefit-icon">⭐</span>
              <div>
                <h3>Personal Library</h3>
                <p>Save your favorite books and track your reading journey in one place</p>
              </div>
            </li>
          </ul>
        </div>
        <div className="auth-card">
          <h1>Welcome Back</h1>
          <p className="auth-subtitle">Sign in to continue</p>
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="your@email.com"
              />
            </div>
            <div className="input-group">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="••••••••"
              />
            </div>
            {error && <div className="error">{error}</div>}
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
          <p className="auth-footer">
            Don't have an account? <Link to="/register">Sign up</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
